import BaseComponent from './BaseComponent';
import Vimeo from '@vimeo/player';
import { track } from '../utils';

let components = [];

export default class VideoPlayer extends BaseComponent {
	constructor(element) {
		super();
		this.element = element;
		this.playButton = this.element.querySelector('[data-play-button]');
		this.iframe = this.element.querySelector('iframe');
		this.player = new Vimeo(this.iframe);

		this.playButton.addEventListener('click', () => {
			this.element.classList.add('is-active');
			this.player.play();

			this.player
				.getVideoTitle()
				.then((title) => {
					track('Play video', {
						props: {
							title: title,
						},
					});
				})
				.catch(function (error) {
					console.error(error);
				});
		});
	}

	destroy() {
		super.destroy();

		if (this.player) {
			this.player.destroy();
		}
	}
}

document.addEventListener('bless', (e) => {
	components.forEach((component) => component.destroy());
	components = [];

	const container = e.detail?.next?.container;

	if (!container) {
		return;
	}

	[...container.querySelectorAll('[data-video-player]')].forEach((element) => {
		components.push(new VideoPlayer(element));
	});
});
